import useSWR from "swr";
import { simpleFetcher } from "../fetcher";

export interface LegacyVersionTarget {
  documentId: number;
  releaseId: number;
}

export function useLegacyVersionTarget(versionId?: number | string | null) {
  const { data, error, isLoading } = useSWR<LegacyVersionTarget, Error>(
    versionId ? `/api/v2/document-releases/legacy-version/${versionId}` : null,
    simpleFetcher,
  );

  return { data, error, isLoading };
}
